<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">I dedicate INFLAGRANTE AND DELICTA –</p>
<p style="text-align: center;">THE COMMON PERIOD</p>
<p style="text-align: center;">to my late parents,</p>
<p style="text-align: center;">Gerry and Philip</p>
<p style="text-align: center;">who loved me and were proud of me, and still do, and still are.</p><br/>
<p style="text-align: center;">I also dedicate my book to my siblings Hilary, Kevin, Stuart and Clive, and to Jax, who also love me and are also proud of me.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?5daa6332